
<template>
  <RecordsCard
    :title="$t('recordsCard.coldestDays.title')"
    :subtitle="$t('recordsCard.coldestDays.subtitle')"
    :data="coldestDays.slice(0,5)"
    :footer="coldestDaysFooter"
    :options="{
      date: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      },
      unit: '&deg;F',
    }"
  />
</template>
<script setup lang="ts">
import RecordsCard from '~/components/RecordsCard.vue'
const { locale, t } = useI18n()
import {desc, op} from "arquero";
const props = defineProps({
  data: {
    required: true,
    type: Object,
  },
  selectedMonth: {
    required: false,
    type: Number,
    default: null
  }
})



const coldestDays = computed(() => {
  return props.data
      .select({ date: "title", minTemp: "value" })
      .objects();
});

const coldestDaysFooter = computed(() => {
  if (props.selectedMonth !== null) return ''
  let string = "";
  const summary = props.data.derive({
    month: d => op.month(d.date)
  })
      .groupby('month')
      .rollup({count: d => op.count()})
      .orderby(desc('count'))
      .derive({
        monthDate: d => op.utcdatetime(2021,d.month,1)
      })

  const mostCommonMonth = summary.object()
  if (mostCommonMonth.count === 5) {
    return t('recordsCard.coldestDays.footer5', {monthName: mostCommonMonth.monthDate.toLocaleDateString(locale, {month: 'long'})})
  } else {
    const monthList = summary.dedupe('month').objects()

    const monthNames = monthList.map((month) => {
          return month.monthDate.toLocaleDateString(locale, {month: 'long'}) + ' ' + month.count + ' (' + month.count + ' times)'
        }
    )
    return t('recordsCard.coldestDays.footer-rest',{monthNames: monthNames.join(', ')})
  }


});

</script>
<script lang="ts">
export default {
  name: 'ColdestDaysCard',
}
</script>